import { DxDataGridComponent } from 'devextreme-angular';
import { ActivatedRoute, Params } from '@angular/router';
import { TaskService, Task, CoreTaskDataField, TaskSelectValue } from './../task.service';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { Title } from '@angular/platform-browser';
import { NotificationService } from 'src/app/services/notification.service';
import { Project, ProjectService } from '../../general/project.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { Subject } from 'rxjs';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { InfoBoxService } from 'src/app/services/info-box.service';

enum CounterGroups {
	PAGE_LOAD = 1
}

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.scss'],
    standalone: false
})
export class TaskListComponent implements OnInit {
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	public allTasks: Task[];

	taskDataSource: Task[];
	columnsDataSource: CoreTaskDataField[] = [];
	currentlySelectedTask = new Task();
	showEditTaskPopup = false;
	selectedTasks: Task[] = [];
	statuses: string[] = [];
	users: string[] = [];
	priorities: string[] = [];
	public projects: Project[] = [];
	public unsavedChanges = false;
	fitTableToPage = false;
	anyActiveFilters = false;

	// <General>
	private readonly _componentTitle = "Task List";

	private _infoBoxService: InfoBoxService = inject(InfoBoxService);

	constructor(
		private taskService: TaskService,
		private route: ActivatedRoute,
		private navigates: NavigateAssociates,
		private titleService: Title,
		private notificationService: NotificationService,
		private projectService: ProjectService,
		private fileExportService: FileExportService,
		private tableParamService: TableParameterService,
	) { }

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.loadPageInfo();

		const taskid = this.route.snapshot.queryParamMap.get("id");

		if (taskid != null && !isNaN(Number(taskid))) {
			this.taskService.getCoreTaskById(
				Number(taskid),
				{
					showLoadingIndicator: true
				}
			).subscribe(
				{
					next: (task: Task) => {
						this.currentlySelectedTask = task;
						this.showEditTaskPopup = true;
					}
				}
			);
		}

		this.projectService.getTasks(
			{
				showLoadingIndicator: true
			}
		).subscribe(
			{
				next: (tasks: Task[]) => {
					this.allTasks = tasks;
				}
			}
		);

		this.projectService.getProjects().subscribe(
			(response) => {
				this.projects = response.sort(
					(a, b) => a.createdOn > b.createdOn ? -1 : 1
				);
			}
		);

		this.GetSettingsData();
	}

	IsExportListEnable = false;

	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportTaskList").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	public loadPageInfo() {
		this.route.queryParams.subscribe(
			(params: Params) => {
				this.users = [];
				this.statuses = [];
				this.priorities = [];

				if (!params.taskUrl) {
					this.taskService.getDynamicCoreTasks(
						{
							showLoadingIndicator: true
						}
					).subscribe(
						{
							next: (response) => {
								
								this.taskDataSource = response.values;
								this.columnsDataSource = response.fields;

								this.columnsDataSource.forEach(
									(coreTaskDataField: CoreTaskDataField) => {
										const firstChar = coreTaskDataField.fieldName[0];
										const secPart = coreTaskDataField.fieldName.slice(1, coreTaskDataField.fieldName.length);

										coreTaskDataField.fieldName = firstChar.toLowerCase() + secPart;
									}
								);
							}
						}
					);
				} else {
					this.taskService.getDynamicCoreTasksForUrl(
						params.taskUrl,
						{
							showLoadingIndicator: true
						}
					).subscribe(
						{
							next: (response) => {
								this.taskDataSource = response.values;
								this.columnsDataSource = response.fields;

								this.columnsDataSource.forEach(
									(coreTaskDataField: CoreTaskDataField) => {
										const firstChar = coreTaskDataField.fieldName[0];
										const secPart = coreTaskDataField.fieldName.slice(1, coreTaskDataField.fieldName.length);

										coreTaskDataField.fieldName = firstChar.toLowerCase() + secPart;
									}
								);
							}
						}
					);
				}

				this.taskService.getTaskStatuses().subscribe(
					{
						next: (taskSelectValues: TaskSelectValue[]) => {
							this.statuses = taskSelectValues.map((value) => value.listElement);
						}
					}
				);

				this.taskService.getUserList().subscribe(
					{
						next: (response) => {
							this.users = response;
						}
					}
				);

				this.taskService.getTaskPriorities().subscribe(
					(taskSelectValues: TaskSelectValue[]) => {
						this.priorities = taskSelectValues.map((value) => value.listElement);
					}
				);
			}
		);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;


		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
		}
	}

	public saveAllChanges() {
		if (this.unsavedChanges) {
			this.taskService.updateMultipleTasks(
				this.taskDataSource,
				{
					showLoadingIndicator: true
				}
			).subscribe(
				{
					next: (_) => {
						this._infoBoxService.show(
							{
								title: 'Saved',
								message: 'Changes Saved Successfully!'
							}
						);

						this.unsavedChanges = false;
					}
				}
			);
		} else {
			this._infoBoxService.show(
				{
					title: 'Warning',
					message: 'No changes have been done yet.'
				}
			);
		}
	}

	public undoAllChanges() {
		if (this.unsavedChanges) {
			this.loadPageInfo();
			this.unsavedChanges = false;
		} else {
			this._infoBoxService.show(
				{
					title: 'Warning',
					message: 'No changes have been done yet.'
				}
			);
		}
	}

	public deleteSelectedTasks() {
		this.taskService.deleteTasks(
			this.selectedTasks,
			{
				showLoadingIndicator: true
			}
		).subscribe(
			{
				next: (_) => {
					this.taskService.getCoreTasks(
						{
							showLoadingIndicator: true
						}
					).subscribe(
						{
							next: (tasks: Task[]) => {
								this.taskDataSource = tasks;

								this._infoBoxService.show(
									{
										title: 'Deleted',
										message: 'Tasks deleted successfully!'
									}
								);
							}
						}
					);
				}
			}
		);
	}

	public editButtonClicked(e, data) {
		this.cleanTaskEvnt();
		e.event.stopPropagation();

		this.taskService.getCoreTaskById(
			data.data.taskId,
			{
				showLoadingIndicator: true
			}
		).subscribe(
			{
				next: (task: Task) => {
					
					this.currentlySelectedTask = task;
					this.currentlySelectedTask.progress = task.progress;
					
					this.showEditTaskPopup = true;
				}
			}
		);
	}

	public rowButtonClicked(e, data) {
		e.event.stopPropagation();

		var link = data.data.link;
		if (link.indexOf('?') > -1) {
			link += '&taskid=' + data.data.taskId;
		}
		else {
			link += '?taskid=' + data.data.taskId;
		}

		this.navigates.navigateTO(link);
	}

	taskGridSelectionChanged(data: any) {
		this.selectedTasks = [];

		data.selectedRowKeys.forEach(element => {
			if (!this.selectedTasks.includes(element)) {
				this.selectedTasks.push(element);
			}
		});
	}

	gridRowUpdated(e) {
		this.unsavedChanges = true;
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		localStorage.setItem('grid-state-task-list', JSON.stringify(this.dataGrid.instance.state()));
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'before',
			template: 'changeFitToButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'deleteButtonTemplate'
		}, {
			location: 'before',
			template: 'saveAllButtonTemplate'
		}, {
			location: 'before',
			template: 'undoAllButtonTemplate'
		});
	}

	cleanTaskSubject: Subject<void> = new Subject<void>();
	cleanTaskEvnt() {
		this.currentlySelectedTask.taskId = null;
		this.currentlySelectedTask.taskName = "";
		this.currentlySelectedTask.taskDescription = "";
		this.currentlySelectedTask.responsibleUser = null;
		this.currentlySelectedTask.createdDate = null;
		this.currentlySelectedTask.startDate = null;
		this.currentlySelectedTask.deadlineDate = null;
		this.currentlySelectedTask.priority = "";
		this.currentlySelectedTask.allowReminder = null;
		this.currentlySelectedTask.link = "";
		this.currentlySelectedTask.solutionDescription = "";
		this.currentlySelectedTask.taskGroup1 = "";
		this.currentlySelectedTask.taskGroup2 = "";
		this.currentlySelectedTask.taskGroup3 = "";
		this.currentlySelectedTask.taskGroup4 = "";
		this.currentlySelectedTask.taskGroup5 = "";
		this.currentlySelectedTask.parentTaskId = null;
		this.currentlySelectedTask.progress = 0;
		this.currentlySelectedTask.projectId = null;
		this.currentlySelectedTask.projectName = "";
		this.currentlySelectedTask.status = "";
		this.currentlySelectedTask.taskFilterData = [];
		this.currentlySelectedTask.isActive = null;
	}
}
